











































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'

interface Employer {
    name: string | null;
}

@Component
export default class EmploymentDetailsForm extends Vue {

    @Prop()
    formEndpoint!: string;

    @Prop()
    previousStepHref!: string;

    @Prop()
    isEmployed!: boolean | null;

    @Prop({
        default: []
    })
    employersProp!: Employer[];

    private employedDuringTheYear: boolean | null = this.isEmployed;
    private numberOfEmployers: number = this.employersProp.length;

    private employers: Employer[] = this.employersProp;

    private loading: boolean = false;

    @Watch('numberOfEmployers')
    private onNumberOfEmployersChanged(newNumber: number) {
        const currentNumber = this.employers.length;
        if (newNumber < currentNumber) {
            while (this.employers.length !== newNumber) {
                this.employers.pop()
            }
        } else if (newNumber > currentNumber) {
            while (this.employers.length !== newNumber) {
                this.employers.push({
                    name: null
                });
            }
        }
    }
}
